






import { Prop, Component, Vue } from 'vue-property-decorator'
import { stringify } from 'query-string'

@Component
export default class GoogleMaps extends Vue {
    readonly apiKey: string = 'AIzaSyACIjqaQKMV_NdVKNjE21csDsHEQl86cH4'
    @Prop({ required: true }) readonly location!: string
    @Prop({ default: 'roadmap' }) readonly maptype!: string
    @Prop({ default: '512' }) readonly width!: string
    @Prop({ default: '260' }) readonly height!: string
    @Prop({ default: 18 }) readonly zoom!: number
    @Prop({ default: 2 }) readonly scale!: number

    get imageSource() {
        return `https://maps.googleapis.com/maps/api/staticmap?` + stringify({
            key: this.apiKey,
            size: `${this.width}x${this.height}`,
            zoom: this.zoom,
            center: this.location,
            scale: this.scale,
            maptype: this.maptype,
            markers: [
                `color:0x00a389|${this.location}`,
            ],
        })
    }
}
